import { useState, useContext, useEffect } from "react";
import { RiCloseFill } from "react-icons/ri"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import ApiContext from "src/provider/API/call-service";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { AbsoluteContainer, AppSpan, AppText, Button, FlexColumn, FlexRow, Form, FormGroup, GridContainer, SidePopupContainer } from "src/style"
import helpers from "src/utils/helpers";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { handleAmountChange } from "src/utils/utility";
import '../style.scss'
import { useTranslation } from "react-i18next";



export const ChangeLimit: React.FC<any> = ({isNewUserCheck, close, accounts}) => {
    const {notifier} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({
        accountNumber: accounts[0]?.accountNumber || '',
        oneTimeTransactionLimit: '', 
        dailyTransactionLimit: '',
        disableCustomerUpdate: false
    })
    const { t } = useTranslation()


    //Display values
    const [singleTransactionLimit, setSingleTransactionLimit] = useState('')
    const [dailyTransactionLimit, setDailyTransactionLimit] = useState('')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit(
      e: React.FormEvent<HTMLButtonElement | HTMLFormElement>
    ) {
      e.preventDefault();
      const response = await API.updateTransactionLimit({
        ...input,
        profileID: accounts[0]?.profileID
      });
     if(response?.isSuccessful === true){
        close()
     }
    }

    useEffect(() => {
        if (accounts && accounts.length > 0) {
            setInput((prevInput) => ({
              ...prevInput,
              accountNumber: accounts[0].accountNumber.toString(),
              oneTimeTransactionLimit: accounts[0].oneTimeLimit.toString(), 
              dailyTransactionLimit: accounts[0].dailyLimit.toString(),
            }));

            setSingleTransactionLimit(accounts[0].oneTimeLimit.toString());
            setDailyTransactionLimit(accounts[0].dailyLimit.toString());
          }
      }, [accounts]);

      useEffect(() => {
        const selectedAccount = accounts.find(
            (acc: any) => acc.accountNumber.toString() === input.accountNumber
        );
    
        if (selectedAccount) {
            setSingleTransactionLimit(selectedAccount.oneTimeLimit.toString());
            setDailyTransactionLimit(selectedAccount.dailyLimit.toString());
        }
    }, [input.accountNumber, accounts]);

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={isNewUserCheck ? null : close} />
            <FlexColumn
                className="new-ads-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                { !isNewUserCheck &&
                    <AbsoluteContainer top='1.5' right='1.5'>
                        <Button 
                            titleSize="2" fontWeight="500"
                            width='3.4' shadow='none'
                            height='3.4'
                            radius='0.4'
                            bgColor='#ffffff'
                            hoverBgColor='#FEF3F2'
                            borderColor='none'
                            color='#000000'
                            hoverColor='#B42318'
                            onClick={close}
                        >
                            <RiCloseFill style={{fontSize: '2.3rem'}} />
                        </Button> 
                    </AbsoluteContainer>
                }
                <AppText color='#101828' textSize="2" fontWeight="700" fontFamily="Gilmer-Bold">
                    {t('customer.profile.changeLimit.title')}
                </AppText>
                <Form onSubmit={handleSubmit} topMargin='1'>
                    <FormGroup>
                        <label style={{fontSize:'1.6rem'}}>{t('customer.profile.changeLimit.accountNumber')}</label>
                        <select
                            placeholder={t('customer.profile.changeLimit.selectAccount')}
                            name='accountNumber'
                            value={input.accountNumber}
                            onChange={handleInput}
                            required
                        >
                            {accounts && accounts?.map((item:any, index:number) => (
                                <option key={index} value={item.accountNumber} >
                                    {item.accountNumber}
                                </option>
                            ))}
                        </select>
                    </FormGroup> 
                    <FormGroup>
                        <label style={{fontSize:'1.6rem'}}>{t('customer.profile.changeLimit.singleLimit')}</label>
                        <input 
                            placeholder="" 
                            name='oneTimeTransactionLimit'
                            type={'text'}
                            value={singleTransactionLimit}
                            onChange={(e)=> {handleAmountChange(e.target.value,setSingleTransactionLimit,setInput,input, e.target.name)}}
                            required
                        />
                    </FormGroup> 
                    <FormGroup>
                        <label style={{fontSize:'1.6rem'}}>{t('customer.profile.changeLimit.dailyLimit')}</label>
                        <input 
                            placeholder="" 
                            name='dailyTransactionLimit'
                            type={'text'}
                            value={dailyTransactionLimit}
                            onChange={(e)=> {handleAmountChange(e.target.value,setDailyTransactionLimit,setInput,input, e.target.name)}}
                            required
                        />
                    </FormGroup> 
                    <FlexRow justifyContent="flex-start" alignItems="center">
                        <label className="checkbox-label" >
                            <input  
                           className="checkbox"
                            type="checkbox"
                                name="disableCustomerUpdate"
                                required
                                checked={input.disableCustomerUpdate}
                                onChange={(e) =>
                                    setInput({
                                        ...input,
                                        disableCustomerUpdate: e.target.checked ? true :false
                                    })
                                }
                              />
                            {t('customer.profile.changeLimit.disableUpdate')}
                        </label>
                    </FlexRow>
                    
                    <FlexRow justifyContent='flex-end'>
                      
                        <Button
                            width='12.9'
                            titleSize='1.4' fontWeight='600'
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                            onClick={handleSubmit}
                        >
                            {t('customer.profile.actions.saveChanges')}
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}